module.exports = __webpack_public_path__ + "media/images/icons/loop-3abc5ef142f3ec2a7137f66bd925a5ee.svg";